// call this file from a bmo-starterkit index.js
// import BMOCore from 'scripts/core/';
// BMOCore.init();
import Tracking from './tracking';
import Social from './social';
import Video from './video';
import Lazy from './lazy';
import General from './general';
import RespImage from './resp-image';
import RespSvg from './resp-svg';
import $ from 'jquery';

// we need this for tracking :/
window.jQuery = $;

function init() {
  Lazy.init();
  Video.init();
  General.init();
  RespImage.init();
  RespSvg.init();
  Tracking.init();
  Social.init();
}

export default {
  init
};
